module.exports = __webpack_public_path__ + "img/cross-circle-lg-icon.876e3f87.svg";